import React from "react";

import { CProgress } from "@coreui/react";

import Charts from "../../Charts";
import "./styles.scss";

const AcertosPorQuestao = ({ applications, list }) => {
  const getQuestionPercentage = questionId => {
    const sameApplications = applications.filter(
      application =>
        application.answers.find(answer => answer.question_id === questionId)
          ?.correct
    );

    return (sameApplications.length / applications.length) * 100;
  };

  const getQuestionQuantity = questionId => {
    const sameApplications = applications.filter(
      application =>
        application.answers.find(answer => answer.question_id === questionId)
          ?.correct
    );

    return sameApplications.length;
  };

  return (
    <>
      <div className="management-1statistics mb-5">
        <div className="row">
          <div className="chart">
            <Charts
              legendY="Questões"
              legendX="Acertos %"
              type="horizontalbar"
              title=""
              data={{
                labels:
                  list.questions?.map(
                    (question, index) => `Questão ${index + 1}`
                  ) || [],
                datasets: [
                  {
                    data: [
                      ...(list.questions?.map(question =>
                        getQuestionPercentage(question.id)
                      ) || []),
                      100
                    ],
                    backgroundColor: [
                      "rgba(255, 99, 132, 0.2)",
                      "rgba(54, 162, 235, 0.2)",
                      "rgba(255, 206, 86, 0.2)",
                      "rgba(75, 192, 192, 0.2)",
                      "rgba(153, 102, 255, 0.2)",
                      "rgba(255, 159, 64, 0.2)",
                      "rgba(255, 0, 41, 0.2)",
                      "rgba(55, 126, 184, 0.2)",
                      "rgba(102, 166, 30, 0.2)",
                      "rgba(152, 78, 163, 0.2)",
                      "rgba(0, 210, 213, 0.2)",
                      "rgba(255, 127, 0, 0.2)",
                      "rgba(254, 224, 182, 0.2)",
                      "rgba(127, 128, 205, 0.2)",
                      "rgba(179, 233, 0, 0.2)",
                      "rgba(196, 46, 96, 0.2)"
                    ],
                    borderColor: [
                      "rgba(255, 99, 132, 1)",
                      "rgba(54, 162, 235, 1)",
                      "rgba(255, 206, 86, 1)",
                      "rgba(75, 192, 192, 1)",
                      "rgba(153, 102, 255, 1)",
                      "rgba(255, 159, 64, 1)",
                      "rgba(255, 0, 41, 1)",
                      "rgba(55, 126, 184, 1)",
                      "rgba(102, 166, 30, 1)",
                      "rgba(152, 78, 163, 1)",
                      "rgba(0, 210, 213, 1)",
                      "rgba(255, 127, 0, 1)",
                      "rgba(254, 224, 182, 1)",
                      "rgba(127, 128, 205, 1)",
                      "rgba(179, 233, 0, 1)",
                      "rgba(196, 46, 96, 1)"
                    ],
                    borderWidth: 1
                  }
                ]
              }}
            />
          </div>
        </div>
      </div>

      <div className="" style={{ marginBottom: "40px" }}>
        <table className="table table-hover table-outline mb-0 d-none d-sm-table acertosPorQuestao">
          <thead className="thead-light">
            <th>Questão</th>
            <th>Total de Acertos</th>
            <th>% Acertos</th>
          </thead>
          <tbody>
            {list.questions?.map((question, index) => (
              <tr>
                <td>{index + 1}</td>
                <td className="">{getQuestionQuantity(question.id) || ""}</td>
                <td>
                  <div className="clearfix">
                    <div className="float-left">
                      {getQuestionPercentage(question.id).toFixed(0)}%
                    </div>
                  </div>
                  <CProgress
                    className="progress-xs"
                    color={
                      getQuestionPercentage(question.id).toFixed(0) > 50
                        ? "success"
                        : getQuestionPercentage(question.id).toFixed(0) <= 50 &&
                          getQuestionPercentage(question.id).toFixed(0) >= 30
                        ? "warning"
                        : "danger"
                    }
                    value={getQuestionPercentage(question.id).toFixed(0)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AcertosPorQuestao;
